import { useMemo } from 'react';
import { useQuery } from '@apollo/client/react';
import { useDebounce } from 'use-debounce';
import { OrderByArg } from 'shared/domains/apollo/generated/types';
import { getAllMarketCodes, supportedMarketCodes } from 'shared/domains/markets/config';
import { GlobalSearchDocument } from './GlobalSearch.gql';
import { documentTransform } from './documentTransform';
import { transformSearchQuery } from './transformSearchQuery';
import { useSearchContext } from '../../components/SearchProvider';
export function useSearchQuery(variables, options) {
    const { values, modifiers } = useSearchContext();
    const { query, filters, referrer, offset, limit, orderBy, columns } = values;
    const { where } = variables || {};
    const activeColumns = useMemo(() => columns.filter((col) => col.active).map((col) => col.id), [columns]);
    const queryDocument = useMemo(() => documentTransform({ columns: activeColumns }).transformDocument(GlobalSearchDocument), [activeColumns]);
    const userMarketCodes = getAllMarketCodes();
    const excludedMarketCodes = supportedMarketCodes.filter((item) => !userMarketCodes.includes(item));
    const [queryVariables] = useDebounce({
        query,
        where: Object.assign(Object.assign(Object.assign({}, filters), where), { marketCode: {
                notIn: excludedMarketCodes,
            } }),
        limit,
        referrer,
        offset,
        orderBy: Object.assign(Object.assign({}, orderBy), { updatedAt: OrderByArg.Desc }),
        modifiers,
    }, 350);
    const { data, loading, error } = useQuery(queryDocument, {
        variables: queryVariables,
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'network-only',
        nextFetchPolicy: 'cache-and-network',
        skip: options === null || options === void 0 ? void 0 : options.skip,
    });
    const transformQueryData = transformSearchQuery(data);
    return {
        data: transformQueryData,
        loading,
        error,
        query,
    };
}
